/**
 * A link into the profile that says which field is missing and where to go
 * afterwards, so a member sent to fix one thing lands on it and finds their way
 * back without hunting.
 *
 *   /profile/details?field=gender&returnTo=/competitions/winter-cup
 */
export type ProfileFixField = 'gender' | 'dob' | 'phone'

export function profileFixLink(field: ProfileFixField, returnTo: string): string {
  const params = new URLSearchParams({ field, returnTo })
  return `/profile/details?${params.toString()}`
}

/**
 * The return path, only if it stays inside this app. Anything else (another
 * origin, a protocol-relative `//evil.example`) is dropped, so the link can
 * never be used to bounce a member off-site.
 */
export function safeReturnTo(value: string | null): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\'))
    return null
  return value
}

export function fixField(value: string | null): ProfileFixField | null {
  return value === 'gender' || value === 'dob' || value === 'phone' ? value : null
}
